import { action } from 'typesafe-actions'
import { CLEAR_INTERFACE, REPLACE_FAVORITES } from '../constants/action-types'
import { FavoriteEntry } from './types'

export const replaceFavorites = (payload: FavoriteEntry[]) =>
  action(REPLACE_FAVORITES, payload)
export const clearInterface = () => action(CLEAR_INTERFACE)
